export default "__VITE_ASSET__Zz6uYvz___"